import React from "react";
import { useAgency } from "@/contexts/AgencyContext";
import { usePageTitle } from "@/hooks/usePageTitle";
import { MobileTabBar } from "./components/MobileTabBar";
import { MobileTopBar } from "./components/MobileTopBar";

interface MobileLayoutProps {
  children: React.ReactNode;
  showTabBar?: boolean;
  pageTitle?: string;
}

/**
 * Shell do app mobile: ocupa a viewport inteira (100dvh). A barra do topo e a
 * barra de abas aparecem só nas telas raiz; telas de detalhe (conversa) usam a
 * altura toda e trazem o próprio cabeçalho com botão voltar.
 */
export const MobileLayout: React.FC<MobileLayoutProps> = ({
  children,
  showTabBar = false,
  pageTitle,
}) => {
  const { agency } = useAgency();

  usePageTitle({
    agencyName: agency?.company_name,
    pageTitle,
  });

  return (
    <div className="flex h-dvh w-full flex-col overflow-hidden bg-background text-foreground">
      {showTabBar && <MobileTopBar />}
      <main className="flex min-h-0 flex-1 flex-col">{children}</main>
      {showTabBar && <MobileTabBar />}
    </div>
  );
};
